// Images.js

export function isBlobUrl(url) {
	return typeof url === 'string' && url.startsWith('blob:');
}

export function createObjectUrl(file) {
	if (!file || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
		return null;
	}

	return URL.createObjectURL(file);
}

export function revokeObjectUrl(url) {
	if (!isBlobUrl(url) || typeof URL === 'undefined' || typeof URL.revokeObjectURL !== 'function') {
		return;
	}

	URL.revokeObjectURL(url);
}

